export default "__VITE_ASSET__LZtzYWwF__"